class Select {
  constructor(elementClass) {
    this.selects = document.querySelectorAll(`.${elementClass}`);
    this.defaultClass = 'js-active';
  }

  init() {
    console.log('js component', this.selects);
    for (const element of this.selects) {
      const input = element.children[0];
      const menu = element.children[2];
      const menuItems = menu.children;

      console.log(input, menu, menuItems, 'items');

      for (const item of menuItems) {
        item.addEventListener('click', function () {
          input.value = this.textContent;
        });
      }

      window.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(element);
        const operation = withinBoundaries ? 'toggle' : 'remove';
        element.classList[operation](this.defaultClass);
      })
    }
  }
}

const select = new Select('select')
select.init()
